import ClassActions from './ClassActions'

export default ClassActions
